// @flow
import * as React from "react";
import cx from "classnames";

import SVG from "react-inlinesvg";
import Popover from "../Popover";

import styles from "./Dropdown.scss";

export type DropdownOptions = Array<{
  text: () => React.Node,
  onClick: (closePopover: () => void) => void,
  title: React.Node
}>;

type DropdownProps = {
  options: DropdownOptions,
  activeIndex: number,
  icon: string,
  popperWidth: number,
  onLeft: boolean,
  additionalStyles: {
    dropdownWrapper: string,
    triggerButton: string,
    icon: string,
    activeButton: string
  }
};

const Dropdown = ({
  options,
  activeIndex,
  icon,
  popperWidth,
  onLeft,
  additionalStyles
}: DropdownProps) => {
  const combinedStyles = [styles, additionalStyles];

  return (
    <div className={cx(...combinedStyles.map(c => c.dropdownWrapper))}>
      <Popover
        input={({ triggerRef, onFocus }) => (
          <button
            className={cx(
              ...combinedStyles.map(c => c.triggerButton),
              ...combinedStyles.map(c => ({ [c.activeButton]: activeIndex >= 0 }))
            )}
            type="button"
            ref={triggerRef}
            data-testid="dropdownTrigger"
            data-closeonshifttab
            aria-label="dropdown"
            onFocus={onFocus}
          >
            <SVG className={cx(...combinedStyles.map(c => c.icon))} src={icon} alt="dropdown" />
          </button>
        )}
        additionalStyles={additionalStyles}
        content={({ closePopover }) => (
          <div className={styles.buttonsWrapper} data-testid="dropdownButtonsWrapper">
            {options.map(({ text, onClick, title }, optionIndex) => {
              const isActive = optionIndex === activeIndex;
              const content = text();

              return (
                <button
                  className={isActive ? styles.isActive : undefined}
                  type="button"
                  onClick={() => onClick(closePopover)}
                  // eslint-disable-next-line react/no-array-index-key
                  key={optionIndex}
                  title={title}
                  data-isactive={isActive}
                  data-closeontab={options.length === optionIndex + 1}
                >
                  {content}
                </button>
              );
            })}
          </div>
        )}
        popperWidth={popperWidth}
        onLeft={onLeft}
      />
    </div>
  );
};

Dropdown.defaultProps = {
  icon: "",
  popperWidth: 200,
  activeIndex: -1,
  additionalStyles: {
    dropdownWrapper: "",
    triggerButton: "",
    icon: ""
  }
};

export default Dropdown;
